/**
 * "Still not working? Contact the Global IT Helpdesk" — Teams or email. No
 * phone number anywhere on the site (20 Oct).
 *
 * The way out for someone the portal cannot help right now: a sign-in that
 * failed, or a ticket, request or comment that would not save after a retry.
 * Without it the only thing on screen is "try again", and a person whose
 * problem is urgent has nowhere to go. The contact details come from
 * `@/lib/helpdesk-contact`, the one copy of them.
 */

import { Icon, Mail, MessageSquare } from "@norican/icons";
import { cn, Typography } from "@norican/react";

import { useT } from "@/i18n";
import { HELPDESK_EMAIL, HELPDESK_EMAIL_HREF, HELPDESK_TEAMS_URL } from "@/lib/helpdesk-contact";

const LINK_CLASS =
  "text-accent-fg-subtle hover:text-accent-hover font-weight-medium inline-flex items-center gap-1.5 underline underline-offset-2";

export interface HelpdeskContactLineProps {
  className?: string;
}

export function HelpdeskContactLine({ className }: HelpdeskContactLineProps) {
  const { t } = useT();

  return (
    <div className={cn("flex flex-col gap-1", className)}>
      <Typography variant="caption" tone="muted">
        {t("helpdeskContact.lead")}
      </Typography>
      <span className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm">
        <a
          href={HELPDESK_TEAMS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={LINK_CLASS}
        >
          <Icon icon={MessageSquare} size="sm" />
          {t("helpdeskContact.teams")}
          <span className="sr-only"> ({t("helpdeskContact.newTab")})</span>
        </a>
        <a href={HELPDESK_EMAIL_HREF} className={LINK_CLASS}>
          <Icon icon={Mail} size="sm" />
          {HELPDESK_EMAIL}
        </a>
      </span>
    </div>
  );
}
